import Icon from 'components/base/Icon';
import { getDeltaProps } from '../tooltip.utils';
import { StyledDelta, StyledZeroLine } from '../Tooltip.style';
import { boolPropsToClassNames } from 'common/utils/style.utils';

const DeltaIndicator = ({ delta }) => {
  if (isNaN(delta)) return null;

  const { isNegative, isPositive, isZero } = getDeltaProps(delta);
  return (
    <StyledDelta
      className={boolPropsToClassNames({ isNegative, isPositive })}
      data-testid='delta-arrow'
    >
      {isZero ? (
        <StyledZeroLine />
      ) : (
        <Icon name={isNegative ? 'ArrowDown' : 'ArrowUp'} size='large' />
      )}
    </StyledDelta>
  );
};

export default DeltaIndicator;
